import { adminConstants } from 'redux/constant/admin-constant';
import { alertActions } from './alert-actions';
import { history } from 'helper/history';
import { emailTemplatesService } from 'services/emailTemplates';

export const emailTemplatesActions = {
    getEmailTemplates,
    getMailTypes,
    storeEmailTemplates,
    editEmailTemplates,
    deleteEmailTemplates,
    getEmailTemplate,
};

function getEmailTemplates(){
	return dispatch => {
        dispatch(request());
        emailTemplatesService.getEmailTemplates()
            .then(
                emailTemplates => {
                    dispatch(success(emailTemplates));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(email) { return { type: adminConstants.GET_EMAIL_TEMPLATES_REQUEST } }
    function success(emailTemplates) { return { type: adminConstants.GET_EMAIL_TEMPLATES_SUCCESS, payload:emailTemplates } }
    function failure(error) { return { type: adminConstants.GET_EMAIL_TEMPLATES_FAILURE, payload:error } }
}

function getMailTypes(){
	return dispatch => {
        dispatch(request());
        emailTemplatesService.getMailTypes()
            .then(
                emailTypes => {
                    dispatch(success(emailTypes));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(email) { return { type: adminConstants.GET_EMAIL_TYPES_REQUEST } }
    function success(emailTypes) { return { type: adminConstants.GET_EMAIL_TYPES_SUCCESS, payload:emailTypes } }
    function failure(error) { return { type: adminConstants.GET_EMAIL_TYPES_FAILURE, payload:error } }
}

function storeEmailTemplates(data){
	return dispatch => {
        dispatch(request());
        return emailTemplatesService.storeEmailTemplates(data)
            .then(
                emailTemplate => {
                	dispatch(alertActions.success(emailTemplate.message));
                    dispatch(success(emailTemplate));
                    return emailTemplate;
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                	return Promise.reject(error);
                }
            );
    };

    function request(email) { return { type: adminConstants.STORE_EMAIL_TEMPLATES_REQUEST } }
    function success(emailTemplate) { return { type: adminConstants.STORE_EMAIL_TEMPLATES_SUCCESS, payload:emailTemplate } }
    function failure(error) { return { type: adminConstants.STORE_EMAIL_TEMPLATES_FAILURE, payload:error } }
}

function editEmailTemplates(data, id){
	return dispatch => {
        dispatch(request());
        return emailTemplatesService.editEmailTemplates(data, id)
            .then(
                emailTemplate => {
                	dispatch(alertActions.success(emailTemplate.message));
                    dispatch(success(emailTemplate));
                    return emailTemplate;
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                	return Promise.reject(error);
                }
            );
    };

    function request(email) { return { type: adminConstants.EDIT_EMAIL_TEMPLATES_REQUEST } }
    function success(emailTemplate) { return { type: adminConstants.EDIT_EMAIL_TEMPLATES_SUCCESS, payload:emailTemplate } }
    function failure(error) { return { type: adminConstants.EDIT_EMAIL_TEMPLATES_FAILURE, payload:error } }
}

function deleteEmailTemplates(id){
	return dispatch => {
        dispatch(request());
        return emailTemplatesService.deleteEmailTemplates(id)
            .then(
                emailTemplate => {
                	dispatch(alertActions.success(emailTemplate.message));
                    dispatch(success(emailTemplate));
                    return emailTemplate;
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                	
                }
            );
    };

    function request(email) { return { type: adminConstants.DELETE_EMAIL_TEMPLATES_REQUEST } }
    function success(emailTemplate) { return { type: adminConstants.DELETE_EMAIL_TEMPLATES_SUCCESS, payload:emailTemplate } }
    function failure(error) { return { type: adminConstants.DELETE_EMAIL_TEMPLATES_FAILURE, payload:error } }
}

function getEmailTemplate(typeName){
	return dispatch => {
        dispatch(request());
        return emailTemplatesService.getEmailTemplate(typeName)
            .then(
                response => {
                    dispatch(success(response));
                	return response.emailTemplate;
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(email) { return { type: adminConstants.GET_EMAIL_TEMPLATE_REQUEST } }
    function success(response) { return { type: adminConstants.GET_EMAIL_TEMPLATE_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_EMAIL_TEMPLATE_FAILURE, payload:error } }
}



// WEBPACK FOOTER //
// ./src/redux/actions/email-templates-action.jsx